import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class SalesOrderModel extends Model {
  static reducer(action, SalesOrderModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.SalesOrder.schema:
        action.payload.forEach((payload) => {
          const dbData = SalesOrderModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          SalesOrderModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
SalesOrderModel.modelName = "SalesOrderModel";

SalesOrderModel.fields = {
  id: attr(),
};

export default SalesOrderModel;